import { useFormik } from "formik";
import moment from "moment";
import { useState } from "react";
import toast from "react-hot-toast";
import { useQuery } from "react-query";
import Swal from "sweetalert2";
import bit from "../../assets/logo.png";
import { apiConnectorGet, apiConnectorPost } from "../../utils/APIConnector";
import { endpoint } from "../../utils/APIRoutes";
import { areYouSureFn, formatedDate, getFloatingValue } from "../../utils/utilityFun";

/* ─── Sub-components ─── */

const ModalButtons = ({ onClose, loading }) => (
  <div className="flex justify-end gap-3 mt-2">
    <button
      type="button"
      onClick={onClose}
      className="px-5 py-2 rounded-lg text-xs font-semibold transition-all duration-200"
      style={{ background: "rgba(239,68,68,0.06)", border: "1px solid rgba(239,68,68,0.18)", color: "rgba(252,165,165,0.75)" }}
      onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(239,68,68,0.13)"; e.currentTarget.style.borderColor = "rgba(239,68,68,0.35)"; e.currentTarget.style.color = "rgba(252,165,165,1)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(239,68,68,0.06)"; e.currentTarget.style.borderColor = "rgba(239,68,68,0.18)"; e.currentTarget.style.color = "rgba(252,165,165,0.75)"; }}
    >
      Cancel
    </button>
    <button
      type="submit"
      disabled={loading}
      className="relative px-6 py-2 rounded-lg text-xs font-bold overflow-hidden group/btn transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
      style={{ background: "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)", border: "1px solid rgba(37,99,235,0.5)", color: "#fff" }}
    >
      <div className="absolute inset-0 translate-x-[-100%] group-hover/btn:translate-x-[100%] transition-transform duration-500 bg-gradient-to-r from-transparent via-white/15 to-transparent pointer-events-none" />
      <span className="relative z-10">
        {loading ? (
          <span className="flex items-center gap-1.5">
            <svg className="animate-spin w-3 h-3" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
            </svg>
            Saving...
          </span>
        ) : "Save"}
      </span>
    </button>
  </div>
);

const InfoRow = ({ label, value }) => (
  <div
    className="flex justify-between items-center px-3 py-2.5 rounded-lg hover:bg-white/[0.02] transition-colors duration-200"
    style={{ borderBottom: "1px solid rgba(37,99,235,0.10)" }}
  >
    <span className="text-[#475569] text-[10px] font-semibold uppercase tracking-widest">{label}</span>
    <span className="font-semibold text-sm text-right max-w-[55%] truncate text-[#7DD3FC]">{value}</span>
  </div>
);

const Card = ({ children, className = "" }) => (
  <div
    className={`rounded-2xl relative overflow-hidden ${className}`}
    style={{
      background: "linear-gradient(135deg, rgba(6,14,28,0.97) 0%, rgba(8,15,28,0.95) 100%)",
      border: "1px solid rgba(37,99,235,0.2)",
      boxShadow: "0 10px 36px rgba(0,0,0,0.45)",
    }}
  >
    <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#22D3EE] via-[#2563EB] to-[#1D4ED8] rounded-l-2xl" />
    <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#2563EB]/40 to-transparent" />
    <div className="absolute top-0 right-0 w-16 h-16 pointer-events-none"
      style={{ borderTop: "1px solid rgba(37,99,235,0.2)", borderRight: "1px solid rgba(37,99,235,0.2)", borderTopRightRadius: "1rem" }} />
    <div className="absolute top-0 right-0 w-40 h-40 rounded-full blur-3xl pointer-events-none"
      style={{ background: "rgba(37,99,235,0.06)" }} />
    {children}
  </div>
);

const CardHeader = ({ title }) => (
  <div className="flex items-center gap-2 px-5 py-4" style={{ borderBottom: "1px solid rgba(255,255,255,0.04)" }}>
    <div className="w-1.5 h-1.5 rounded-full animate-pulse bg-[#2563EB]" />
    <h3 className="text-[11px] font-bold tracking-widest uppercase text-[#7DD3FC]">{title}</h3>
    <div className="flex-1 h-px ml-2" style={{ background: "linear-gradient(90deg, rgba(37,99,235,0.3), transparent)" }} />
  </div>
);

/* ─── Main Component ─── */

const Profile = () => {
  const [loding, setLoding] = useState(false);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showOldPass, setShowOldPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);

  const { data: profile, refetch: refetchProfile } = useQuery(
    ["get_profile"],
    () => apiConnectorGet(endpoint?.profile_api),
    { refetchOnMount: false, refetchOnReconnect: false, refetchOnWindowFocus: false }
  );
  const user_profile = profile?.data?.result?.[0] || {};

  const fkProfile = useFormik({
    initialValues: {
      name: user_profile?.lgn_name || "",
      newPass: "",
      oldPass: "",
      mobile: user_profile?.lgn_mobile || "",
      wallet: user_profile?.wallet_Address || "",
    },
    enableReinitialize: true,
    onSubmit: () => UpdateProfileFn(fkProfile.values),
  });

  async function UpdateProfileFn(reqbody) {
    setLoding(true);
    try {
      const res = await apiConnectorPost(endpoint?.update_profile, reqbody);
      Swal.fire({
        title: String(res?.data?.success) === "true" ? "Congratulations!" : "Error!",
        text: res?.data?.message,
        icon: String(res?.data?.success) === "true" ? "success" : "error",
        confirmButtonColor: "#2563EB",
      });
      if (res?.data?.success) {
        setShowProfileModal(false);
        refetchProfile();
        fkProfile.handleReset();
      }
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data?.message || "Failed to update profile.");
    }
    setLoding(false);
  }

  const walletStats = [
    { label: "Total Income", value: getFloatingValue(user_profile?.tr03_total_income) + " USD", icon: "M13 7h8m0 0v8m0-8l-8 8-4-4-6 6", color: "#22D3EE" },
    { label: "Topup Wallet", value: getFloatingValue(user_profile?.tr03_topup_wallet) + " USD", icon: "M12 6v6m0 0v6m0-6h6m-6 0H6", color: "#2563EB" },
    { label: "Fund Wallet", value: getFloatingValue(user_profile?.tr03_fund_wallet) + " USD", icon: "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z", color: "#818CF8" },
    { label: "Income Wallet", value: getFloatingValue(user_profile?.tr03_inc_wallet) + " USD", icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z", color: "#34D399" },
  ];

  const inputStyle = {
    background: "rgba(6,14,28,0.8)",
    border: "1px solid rgba(37,99,235,0.25)",
    color: "rgba(226,232,240,0.95)",
  };
  const inputFocus = (e) => { e.target.style.borderColor = "rgba(37,99,235,0.6)"; e.target.style.boxShadow = "0 0 0 3px rgba(37,99,235,0.12)"; };
  const inputBlur = (e) => { e.target.style.borderColor = "rgba(37,99,235,0.25)"; e.target.style.boxShadow = "none"; };

  return (
    <>
      <div
        className="relative min-h-screen pb-8"
        style={{ background: "linear-gradient(160deg, #060E1C 0%, #080F1C 50%, #0B1E36 100%)" }}
      >
        {/* Grid overlay */}
        <div className="absolute inset-0 pointer-events-none" style={{
          backgroundImage: "linear-gradient(rgba(37,99,235,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(37,99,235,0.03) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }} />
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full blur-3xl pointer-events-none" style={{ background: "rgba(37,99,235,0.07)" }} />
        <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full blur-3xl pointer-events-none" style={{ background: "rgba(29,78,216,0.05)" }} />

        <div className="relative z-10 max-w-6xl mx-auto space-y-5 px-4 py-6">

          {/* ── Hero Banner ── */}
          <div
            className="rounded-2xl overflow-hidden relative"
            style={{
              background: "linear-gradient(135deg, rgba(6,14,28,0.98) 0%, rgba(8,15,28,0.96) 50%, rgba(11,30,54,0.98) 100%)",
              border: "1px solid rgba(37,99,235,0.22)",
              boxShadow: "0 16px 56px rgba(0,0,0,0.5), 0 0 60px rgba(37,99,235,0.06)",
            }}
          >
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#2563EB]/60 to-transparent" />
            <div className="absolute top-0 left-0 bottom-0 w-0.5 bg-gradient-to-b from-[#22D3EE] via-[#2563EB] to-[#1D4ED8]" />
            <div className="absolute inset-0 opacity-[0.02] pointer-events-none"
              style={{ backgroundImage: "linear-gradient(rgba(37,99,235,1) 1px, transparent 1px), linear-gradient(90deg, rgba(37,99,235,1) 1px, transparent 1px)", backgroundSize: "40px 40px" }} />
            {/* Particles */}
            <div className="absolute bottom-4 right-8 w-1 h-1 bg-[#2563EB] rounded-full opacity-40 animate-ping pointer-events-none" style={{ animationDuration: "3s" }} />
            <div className="absolute top-8 right-24 w-1 h-1 bg-[#22D3EE] rounded-full opacity-30 animate-ping pointer-events-none" style={{ animationDuration: "3s", animationDelay: "1.2s" }} />

            <div className="relative z-10 p-6 sm:p-8">
              <div className="flex items-center justify-between gap-3 mb-5">
                <div className="px-3 py-1 rounded-full text-[10px] font-bold tracking-widest uppercase"
                  style={{ background: "rgba(37,99,235,0.15)", border: "1px solid rgba(37,99,235,0.32)", color: "rgba(125,211,252,0.95)" }}>
                  Member Profile
                </div>
                <div className="text-[10px] text-[#334155] tracking-widest uppercase">HEXAFUND · Identity</div>
              </div>

              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6">

                {/* Avatar */}
                <div className="relative flex-shrink-0">
                  <div className="absolute inset-0 rounded-2xl blur-2xl animate-pulse" style={{ background: "rgba(37,99,235,0.2)" }} />
                  <div
                    className="relative w-24 h-24 sm:w-28 sm:h-28 rounded-2xl flex items-center justify-center overflow-hidden"
                    style={{
                      background: "linear-gradient(135deg, rgba(37,99,235,0.15) 0%, rgba(29,78,216,0.10) 100%)",
                      border: "2px solid rgba(37,99,235,0.35)",
                      boxShadow: "0 0 32px rgba(37,99,235,0.2)",
                    }}
                  >
                    <img src={bit} alt="Avatar" className="w-20" />
                  </div>
                  <div
                    className="absolute -bottom-1 -right-1 flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] font-bold tracking-wider"
                    style={{ background: "rgba(52,211,153,0.15)", border: "1px solid rgba(52,211,153,0.4)", color: "#6ee7b7" }}
                  >
                    <div className={`w-1 h-1 rounded-full animate-pulse ${getFloatingValue(user_profile?.tr03_topup_wallet) > 0 ? "bg-emerald-400" : "bg-red-400"}`} />
                    {getFloatingValue(user_profile?.tr03_topup_wallet) > 0 ? "Active" : "Inactive"}
                  </div>
                </div>

                {/* Name / Info */}
                <div className="flex-1 text-center sm:text-left">
                  <h1 className="text-2xl sm:text-4xl font-bold tracking-tight mb-1 text-white">
                    {user_profile?.lgn_name || "—"}
                  </h1>
                  <p className="text-[#475569] text-sm mb-3">{user_profile?.lgn_email || "—"}</p>

                  <div className="flex flex-wrap gap-2 justify-center sm:justify-start mb-3">
                    <button
                      onClick={() => setShowProfileModal(true)}
                      className="px-4 py-2 rounded-lg text-[11px] font-semibold transition-all duration-200 hover:translate-y-[-1px] hover:shadow-[0_0_14px_rgba(37,99,235,0.3)]"
                      style={{ background: "rgba(37,99,235,0.18)", border: "1px solid rgba(37,99,235,0.4)", color: "rgba(125,211,252,0.95)" }}
                    >
                      Edit Profile
                    </button>
                    <button
                      onClick={() => setShowPasswordModal(true)}
                      className="px-4 py-2 rounded-lg text-[11px] font-semibold transition-all duration-200 hover:translate-y-[-1px]"
                      style={{ background: "rgba(34,211,238,0.10)", border: "1px solid rgba(34,211,238,0.25)", color: "rgba(125,211,252,0.92)" }}
                    >
                      Change Password
                    </button>
                  </div>

                  <div className="flex flex-wrap gap-2 justify-center sm:justify-start">
                    <div className="flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-mono"
                      style={{ background: "rgba(37,99,235,0.08)", border: "1px solid rgba(37,99,235,0.22)", color: "rgba(125,211,252,0.9)" }}>
                      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0" />
                      </svg>
                      Self Id: {user_profile?.tr03_cust_id || "—"}
                    </div>
                    <div className="flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-mono"
                      style={{ background: "rgba(34,211,238,0.07)", border: "1px solid rgba(34,211,238,0.18)", color: "rgba(125,211,252,0.85)" }}>
                      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0" />
                      </svg>
                      Sponsor Id: {user_profile?.spon_id || "—"}
                    </div>
                  </div>
                </div>

                {/* Date panel */}
                <div className="w-full sm:w-[200px] rounded-xl p-4 flex-shrink-0"
                  style={{ background: "rgba(37,99,235,0.07)", border: "1px solid rgba(37,99,235,0.18)" }}>
                  <div className="mb-3">
                    <p className="text-[9px] text-[#334155] tracking-widest uppercase mb-0.5">Registered</p>
                    <p className="text-xs font-semibold text-[#7DD3FC]">{formatedDate(moment, user_profile?.tr03_reg_date) || "—"}</p>
                  </div>
                  <div className="h-px bg-gradient-to-r from-transparent via-[#2563EB]/20 to-transparent mb-3" />
                  <div>
                    <p className="text-[9px] text-[#334155] tracking-widest uppercase mb-0.5">Activated</p>
                    <p className="text-xs font-semibold text-[#22D3EE]">{formatedDate(moment, user_profile?.tr03_topup_date) || "—"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ── Wallet Stats ── */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-0.5 h-5 rounded-full bg-gradient-to-b from-[#22D3EE] to-[#2563EB]" />
              <h2 className="text-[11px] font-bold tracking-widest uppercase text-[#7DD3FC]">Wallet Overview</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
              {walletStats.map((item, i) => (
                <div
                  key={i}
                  className="rounded-2xl p-4 transition-all duration-300 hover:translate-y-[-3px]"
                  style={{
                    background: `rgba(6,14,28,0.8)`,
                    border: `1px solid rgba(37,99,235,0.18)`,
                    boxShadow: "0 8px 20px rgba(0,0,0,0.35)",
                  }}
                >
                  <div className="flex items-center gap-2 mb-3">
                    <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke={item.color} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={item.icon} />
                    </svg>
                    <span className="text-[9px] font-bold tracking-widest uppercase text-[#475569]">{item.label}</span>
                  </div>
                  <p className="text-xl font-bold" style={{ color: item.color }}>{item.value}</p>
                  <div className="mt-2 h-0.5 rounded-full overflow-hidden bg-[#1e3a5f]/40">
                    <div className="h-full rounded-full w-2/3" style={{ background: item.color }} />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Account Info + Settings ── */}
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-5">

            {/* Account Info Card */}
            <Card>
              <CardHeader title="Account Information" />
              <div className="px-5 py-4 space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {[
                    { label: "Name", value: user_profile?.lgn_name || "—", color: "#22D3EE" },
                    { label: "Mobile", value: user_profile?.lgn_mobile || "—", color: "#7DD3FC" },
                    { label: "Self ID", value: user_profile?.tr03_cust_id || "—", color: "#2563EB" },
                    { label: "Sponsor ID", value: user_profile?.spon_id || "—", color: "#818CF8" },
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      className="rounded-xl px-3 py-2.5"
                      style={{ background: "rgba(37,99,235,0.07)", border: "1px solid rgba(37,99,235,0.18)" }}
                    >
                      <p className="text-[9px] font-bold uppercase tracking-widest text-[#475569] mb-1">{item.label}</p>
                      <p className="text-sm font-semibold truncate" style={{ color: item.color }} title={item.value}>{item.value}</p>
                    </div>
                  ))}
                </div>

                <div className="rounded-xl p-3" style={{ background: "rgba(37,99,235,0.05)", border: "1px solid rgba(37,99,235,0.14)" }}>
                  <p className="text-[9px] font-bold uppercase tracking-widest text-[#475569] mb-2">Contact & Dates</p>
                  <InfoRow label="Email" value={user_profile?.lgn_email || "—"} />
                  <InfoRow label="Registration Date" value={formatedDate(moment, user_profile?.tr03_reg_date)} />
                  <InfoRow label="Activation Date" value={formatedDate(moment, user_profile?.tr03_topup_date)} />
                </div>

                {user_profile?.jnr_allow_for_team_topup && (
                  <div
                    className="rounded-xl p-3.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
                    style={{ background: "linear-gradient(135deg, rgba(37,99,235,0.14) 0%, rgba(29,78,216,0.10) 100%)", border: "1px solid rgba(37,99,235,0.28)" }}
                  >
                    <div>
                      <p className="text-[9px] text-[#475569] font-bold uppercase tracking-widest mb-1">Team Topup</p>
                      <p className="text-sm font-semibold text-[#E2E8F0]">
                        Balance: <span className="text-[#22D3EE]">{user_profile?.jnr_team_topup_bal}</span>
                      </p>
                    </div>
                    <button
                      className="relative px-4 py-2 rounded-lg text-xs font-bold overflow-hidden group/btn transition-all duration-300 hover:scale-105"
                      style={{ background: "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)", border: "1px solid rgba(37,99,235,0.5)", color: "#fff" }}
                    >
                      <div className="absolute inset-0 translate-x-[-100%] group-hover/btn:translate-x-[100%] transition-transform duration-500 bg-gradient-to-r from-transparent via-white/15 to-transparent pointer-events-none" />
                      <span className="relative z-10">TOPUP</span>
                    </button>
                  </div>
                )}
              </div>
              <div className="pb-4" />
            </Card>

            {/* Profile Settings Card */}
            <Card>
              <CardHeader title="Profile Settings" />
              <div className="px-5 py-5 space-y-4">

                {[
                  {
                    label: "Update Profile",
                    sub: "Name & mobile number",
                    btnLabel: "Edit",
                    icon: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z",
                    onClick: () => setShowProfileModal(true),
                  },
                  {
                    label: "Change Password",
                    sub: "Update your login credentials",
                    btnLabel: "Change",
                    icon: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z",
                    onClick: () => setShowPasswordModal(true),
                  },
                ].map((row, idx) => (
                  <div
                    key={idx}
                    className="flex justify-between items-center px-3 py-3 rounded-xl"
                    style={{ background: "rgba(37,99,235,0.07)", border: "1px solid rgba(37,99,235,0.16)" }}
                  >
                    <div>
                      <p className="text-[#CBD5E1] text-sm font-medium">{row.label}</p>
                      <p className="text-[#475569] text-xs mt-0.5">{row.sub}</p>
                    </div>
                    <button
                      onClick={row.onClick}
                      className="relative px-5 py-2 rounded-lg text-xs font-bold overflow-hidden group/btn transition-all duration-300 hover:scale-105"
                      style={{ background: "rgba(37,99,235,0.18)", border: "1px solid rgba(37,99,235,0.35)", color: "rgba(125,211,252,0.95)" }}
                      onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 0 16px rgba(37,99,235,0.25)"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "none"; }}
                    >
                      <div className="absolute inset-0 translate-x-[-100%] group-hover/btn:translate-x-[100%] transition-transform duration-500 bg-gradient-to-r from-transparent via-white/10 to-transparent pointer-events-none" />
                      <span className="relative z-10 flex items-center gap-1.5">
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={row.icon} />
                        </svg>
                        {row.btnLabel}
                      </span>
                    </button>
                  </div>
                ))}
              </div>
            </Card>
          </div>
        </div>
      </div>

      {/* ══════════ MODALS ══════════ */}

      {/* Password / Wallet modals */}
      {[
        showWalletModal && {
          key: "wallet",
          title: "Add Wallet Address",
          onClose: () => { setShowWalletModal(false); fkProfile.handleReset(); },
          onSubmit: (e) => { e.preventDefault(); areYouSureFn(Swal, () => fkProfile.handleSubmit()); },
          fields: [{ label: "Wallet Address", name: "wallet", type: "text", placeholder: "Enter wallet address", value: fkProfile.values.wallet, onChange: fkProfile.handleChange, mono: true }],
        },
        showPasswordModal && {
          key: "password",
          title: "Change Password",
          onClose: () => { setShowPasswordModal(false); setShowOldPass(false); setShowNewPass(false); fkProfile.handleReset(); },
          onSubmit: (e) => { e.preventDefault(); areYouSureFn(Swal, () => fkProfile.handleSubmit()); },
          fields: [
            { label: "Old Password", name: "oldPass", type: showOldPass ? "text" : "password", placeholder: "Enter old password", value: fkProfile.values.oldPass, onChange: fkProfile.handleChange, isPasswordField: true, isVisible: showOldPass, toggleVisibility: () => setShowOldPass((p) => !p) },
            { label: "New Password", name: "newPass", type: showNewPass ? "text" : "password", placeholder: "Enter new password", value: fkProfile.values.newPass, onChange: fkProfile.handleChange, isPasswordField: true, isVisible: showNewPass, toggleVisibility: () => setShowNewPass((p) => !p) },
          ],
        },
      ].filter(Boolean).map((modal) => (
        <div key={modal.key} className="fixed inset-0 flex items-center justify-center z-50 bg-black/70 backdrop-blur-sm">
          <Card className="w-full max-w-sm mx-4">
            <div className="px-6 py-5" style={{ borderBottom: "1px solid rgba(37,99,235,0.15)" }}>
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#2563EB] animate-pulse" />
                  <h3 className="text-white text-sm font-bold tracking-wide uppercase">{modal.title}</h3>
                </div>
                <button
                  onClick={modal.onClose}
                  className="w-7 h-7 rounded-full flex items-center justify-center text-[#475569] hover:text-red-400 transition-colors duration-200"
                  style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.06)" }}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            <form onSubmit={modal.onSubmit}>
              <div className="px-6 py-5 space-y-4">
                {modal.fields.map((f) => (
                  <div key={f.name}>
                    <label className="block text-[9px] text-[#475569] uppercase tracking-widest mb-2">{f.label}</label>
                    <div className="relative">
                      <input
                        type={f.type} name={f.name} placeholder={f.placeholder}
                        value={f.value} onChange={f.onChange}
                        className={`w-full px-4 py-2.5 rounded-lg text-sm outline-none transition-all duration-200 placeholder:text-[#334155] ${f.mono ? "font-mono" : ""} ${f.isPasswordField ? "pr-10" : ""}`}
                        style={inputStyle}
                        onFocus={inputFocus} onBlur={inputBlur}
                      />
                      {f.isPasswordField && (
                        <button type="button" onClick={f.toggleVisibility}
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#475569] hover:text-[#7DD3FC] transition-colors">
                          {f.isVisible ? (
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.956 9.956 0 012.042-3.368m2.087-1.858A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a9.97 9.97 0 01-4.161 5.065M15 12a3 3 0 11-6 0 3 3 0 016 0zm6 9L3 3" />
                            </svg>
                          ) : (
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div className="px-6 pb-5">
                <ModalButtons onClose={modal.onClose} loading={loding} />
              </div>
            </form>
          </Card>
        </div>
      ))}

      {/* Update Profile Modal */}
      {showProfileModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/70 backdrop-blur-sm">
          <Card className="w-full max-w-sm mx-4">
            <div className="px-6 py-5" style={{ borderBottom: "1px solid rgba(37,99,235,0.2)" }}>
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#22D3EE] animate-pulse" />
                  <h3 className="text-white text-sm font-bold tracking-wide uppercase">Update Profile</h3>
                </div>
                <button
                  onClick={() => { setShowProfileModal(false); fkProfile.handleReset(); }}
                  className="w-7 h-7 rounded-full flex items-center justify-center text-[#475569] hover:text-red-400 transition-colors duration-200"
                  style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.06)" }}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            <form onSubmit={(e) => { e.preventDefault(); areYouSureFn(Swal, () => fkProfile.handleSubmit()); }}>
              <div className="px-6 py-5 space-y-4">
                {[
                  { label: "Name", name: "name", type: "text" },
                  { label: "Mobile", name: "mobile", type: "text" },
                ].map((f) => (
                  <div key={f.name}>
                    <label className="block text-[9px] text-[#475569] uppercase tracking-widest mb-2">
                      {f.label} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type={f.type} name={f.name} id={f.name}
                      value={fkProfile.values[f.name]} onChange={fkProfile.handleChange}
                      className="w-full px-4 py-2.5 rounded-lg text-sm outline-none transition-all duration-200 placeholder:text-[#334155]"
                      style={inputStyle}
                      onFocus={inputFocus} onBlur={inputBlur}
                    />
                  </div>
                ))}
              </div>
              <div className="px-6 pb-5">
                <ModalButtons onClose={() => { setShowProfileModal(false); fkProfile.handleReset(); }} loading={loding} />
              </div>
            </form>
          </Card>
        </div>
      )}
    </>
  );
};

export default Profile;
